import React from 'react';
import { Theme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { Box, Grid, KeyValue } from 'web-library';
import {
  MedicalCondition,
  MedicalDocument,
} from '../../../../../api/candidate/access-arrangement/model';
import DocumentBadge from '../../../../../components/DocumentBadge';
import { formatBytes } from '../../../../../utils/FileUtils';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  topMargin: {
    marginTop: theme.spacing(6),
  },
  documentsContainer: {
    marginTop: theme.spacing(1.5),
  },
  documentBadgeContainer: {
    marginTop: theme.spacing(4),
  },
}));

export interface SubmittedDetailsProps {
  medicalConditions?: MedicalCondition[];
  reason?: string;
  documents?: MedicalDocument[];
}

const SubmittedDetails = ({ medicalConditions, reason, documents }: SubmittedDetailsProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  if (!medicalConditions && !reason && !documents) {
    return <></>;
  }

  const medicalConditionString = medicalConditions
    ?.map((condition: MedicalCondition) => condition.name)
    .join(', ');
  return (
    <Box className={classes.topMargin}>
      <KeyValue
        keyText={t('accessArrangement->>SelectCondition.SubmittedMedicalCondition')}
        valueText={medicalConditionString}
      />
      {reason && (
        <KeyValue
          keyText={t('accessArrangement->>SelectCondition.SubmittedReason')}
          valueText={reason}
        />
      )}
      <KeyValue
        valueText={
          <Grid className={classes.documentsContainer}>
            {documents?.map((document, index) => (
              <DocumentBadge
                key={document.fileUuid}
                className={index !== 0 ? classes.documentBadgeContainer : ''}
                documentName={document.fileName}
                fileSize={formatBytes(document.fileSizeInBytes)}
              />
            ))}
          </Grid>
        }
        keyText={t('accessArrangement->>SelectCondition.SubmittedDocuments')}
      />
    </Box>
  );
};

export default SubmittedDetails;
